var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-sheet', {
    attrs: {
      "color": "white"
    }
  }, [_c('section', {
    staticClass: "clover-section clover-section--1"
  }, [_c('div', {
    staticClass: "clover-spacer clover-spacer--1"
  }), _c('v-img', {
    staticClass: "event-title d-md-none",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/mobile/mobile-title.svg",
      "alt": "클로버 위크 카드 속 숨어있는 행운을 찾아보세요! 2024.08.12 - 2024.08.25"
    }
  }), _c('v-img', {
    staticClass: "event-title d-none d-md-block",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/title.svg",
      "alt": "클로버 위크 카드 속 숨어있는 행운을 찾아보세요! 2024.08.12 - 2024.08.25"
    }
  }), _c('div', {
    staticClass: "clover-spacer clover-spacer--2"
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--1 d-md-none",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/mobile/event-section-title-1.svg",
      "alt": "행운 상품"
    }
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--1 d-none d-md-block",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/event-section-title-1.svg",
      "alt": "행운 상품"
    }
  }), _c('div', {
    staticClass: "clover-spacer clover-spacer--3"
  }), _c('prize-list')], 1), _c('section', [_vm.loading ? _c('score-board', {
    attrs: {
      "logs": _vm.logs
    }
  }) : _vm._e()], 1), _c('section', {
    staticClass: "clover-section clover-section--2"
  }, [_c('div', {
    staticClass: "clover-spacer clover-spacer--4"
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--2 d-md-none",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/mobile/event-section-title-2.svg",
      "alt": "행운 카드 고르기"
    }
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--2 d-none d-md-block",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/event-section-title-2.svg",
      "alt": "행운 카드 고르기"
    }
  }), _c('div', {
    staticClass: "clover-spacer clover-spacer--5"
  }), _c('lucky-cards', {
    on: {
      "init": _vm.init
    }
  }), _c('div', {
    staticClass: "clover-spacer clover-spacer--6"
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--3 d-md-none",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/mobile/event-section-title-3.svg",
      "alt": "나누리 상품권&캐시 어디에 쓰지?"
    }
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--3 d-none d-md-block",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/event-section-title-3.svg",
      "alt": "나누리 상품권&캐시 어디에 쓰지?"
    }
  }), _c('div', {
    staticClass: "clover-spacer clover-spacer--7"
  }), _c('link-cards'), _c('div', {
    staticClass: "clover-spacer clover-spacer--8"
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--4 d-md-none",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/mobile/event-section-title-4.svg",
      "alt": "꼭 확인해주세요!"
    }
  }), _c('v-img', {
    staticClass: "event-section-title event-section-title--4 d-none d-md-block",
    attrs: {
      "eager": "",
      "src": "/images/event/clover/event-section-title-4.svg",
      "alt": "꼭 확인해주세요!"
    }
  }), _c('div', {
    staticClass: "clover-spacer clover-spacer--9"
  }), _c('v-img', {
    staticClass: "precautions d-md-none",
    attrs: {
      "src": "/images/event/clover/mobile/precautions.svg"
    }
  }), _c('v-img', {
    staticClass: "precautions d-none d-md-block",
    attrs: {
      "src": "/images/event/clover/precautions.svg"
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }